import cardTable from './cardTable';
export default cardTable;



// WEBPACK FOOTER //
// ./src/components/cardTable/index.js